// gimme: conversations-inbox-ui 05/26/2020 741c62dc71ca742adbc6d64d61d30de7cb46539f
'use es6';

import { createSelector } from 'reselect';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { getAsyncFocusedThreadDetails } from './getAsyncFocusedThreadDetails';
export const getFocusedThreadDetails = createSelector([getAsyncFocusedThreadDetails], getData);